__turbopack_context__.v({
  "dash": "loading-anim-module__T3MC1q__dash",
  "loading": "loading-anim-module__T3MC1q__loading",
});
